<div class="step-counter">
  Step 1 of {{ isAuthenticator ? '4' : '3' }}
</div>

<div class="form-group"
     [formGroup]="form">
  @switch (verificationType) {
    @case (verificationTypeEnum.SMS) {
      <mat-form-field appearance="outline">
        <mat-label>Enter your phone number</mat-label>

        <input matInput
               type="tel"
               id="txtDisplay"
               formControlName="phoneNumber"
               required
               autofocus>

        <mat-error>
          Valid phone number is required.
        </mat-error>
      </mat-form-field>

      <div>
        <strong>Make sure this number can receive text messages.</strong>
      </div>
    }

    @case(verificationTypeEnum.EMAIL) {
      <mat-form-field appearance="outline">
        <mat-label>Enter your email address</mat-label>

        <input matInput
               type="email"
               id="txtDisplay"
               formControlName="email"
               required
               autofocus>
        <mat-error>
          Valid email address is required.
        </mat-error>
      </mat-form-field>

      <div>
        <strong>Make sure you can access the account for this email address.</strong>
      </div>
    }

    @case(verificationTypeEnum.AUTHENTICATOR) {
      <div>
        Before we begin, please make sure you have installed an authenticator
        app on your phone from your mobile app store.
      </div>
    }
  }

  <div>
    Don't want to use {{ displayName }}?
    <div class="other-option">
      <a href="./EnrollmentOptions">Choose another option</a>
    </div>
  </div>

  @if (!isValid) {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>
      <div class="error-text">
        {{ errorMessage() || 'An error occurred while trying to send the verification code. Please try a different option or contact support for assistance.' }}
      </div>
    </div>
  }

  @if (isSms) {
    <div>
      By providing your phone number, you consent to receive EZLynx Two-Factor Authentication (2FA) text messages containing one-time verification codes
      needed to access your account. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to opt-out. Review our
      <a class="external-link"
       href="https://www1.appliedsystems.com/en-ie/privacy-policy"
          target="_blank">
        Privacy Policy
        <mat-icon>open_in_new</mat-icon>
      </a> and
      <a class="external-link"
      href="https://www1.appliedsystems.com/en-us/terms-of-use/"
          target="_blank">
        Terms of Use
        <mat-icon>open_in_new</mat-icon>
      </a>      
    </div>
  }

  <div class="buttons">
    <button mat-flat-button
            type="submit"
            id="btnSend"
            color="primary"
            (click)="submitForm()">Next</button>
  </div>
</div>
